import { Alert } from '@mui/material';
import { storage } from '../../../services/storageService';
import { StorageKeys } from '../../../services/constants/StorageKeys';
import { Routes } from '../../../routes/RouteConstants';
import AuthLink from './AuthLink';

// The backend deletes a request 24 hours after it started (EmailVerificationService.ROW_LIFETIME);
// after that the code page has nothing left to confirm.
const REQUEST_LIFETIME_MS = 24 * 60 * 60 * 1000;

/**
 * Points back to the code page when this browser still holds the token of a request. A guest who
 * leaves for their mailbox and comes back through the home page lands here, not on the code page,
 * and without this registered again: every new registration is a new token, so the code already
 * in the mailbox no longer worked (2026-10-06, brownsbs).
 */
const PendingVerificationNotice = () => {
  const emailVerification = storage.get(StorageKeys.EMAIL_VERIFICATION);
  // Requests saved before startedAt existed count from their last code.
  const startedAt = emailVerification?.startedAt ?? emailVerification?.sentAt;

  if (!emailVerification?.token || !startedAt || Date.now() - startedAt > REQUEST_LIFETIME_MS) {
    return null;
  }

  // The same words for a registration and a reset: whether a reset mailed anything depends on
  // the account, which the page must not tell (docs/EMAIL_AUTH.md A7, A13).
  return (
    <Alert severity="info" sx={{ width: '100%', mb: 3, boxSizing: 'border-box' }}>
      Már kértél kódot a(z) <strong>{emailVerification.email}</strong> címre. A kód megadására{" "}
      {/* The info alert's colour, not the tenant's: MUI would draw the underline in primary. */}
      <AuthLink to={Routes.VERIFY_EMAIL} sx={{ color: "info.dark", textDecorationColor: (theme) => theme.palette.info.dark }}>ide</AuthLink> kattintva van lehetőséged.
    </Alert>
  );
};

export default PendingVerificationNotice;
